export interface Article {
  id: string;
  title: string;
  summary: string;
  content: string;
  category: string;
  categoryName: string;
  imageSeq: string;
  imageUrl: string;
  author: string;
  authorAvatar: string;
  date: string;
  readCount: number;
  likeCount: number;
  commentCount: number;
  tags: string[];
}

export const articles: Article[] = [
  {
    id: "article-1",
    title: "新手养猫必备清单：从接猫到安家的完整指南",
    summary: "准备接一只小猫咪回家？别急，先看完这份超详细的养猫必备清单，从猫砂盆到猫抓板，从疫苗到驱虫，一篇文章帮你搞定所有准备工作。",
    content: `<p>恭喜你即将成为一位铲屎官！接猫咪回家是一件充满期待的事情，但在此之前，做好充分的准备工作至关重要。以下是一份完整的新手养猫必备清单，帮助你从容迎接新成员的到来。</p>
<h2>一、基础生活用品</h2>
<p><strong>猫砂盆：</strong>建议选择开放式大号猫砂盆，猫咪需要足够的空间转身和刨砂。如果家里空间允许，猫砂盆数量建议为"猫咪数量+1"。</p>
<p><strong>猫砂：</strong>豆腐猫砂和膨润土猫砂是主流选择。豆腐猫砂可冲厕所，环保方便；膨润土猫砂结团性好，除臭效果佳。建议先买小包装试用，找到猫咪最喜欢的类型。</p>
<p><strong>食碗和水碗：</strong>推荐使用陶瓷或不锈钢材质，避免塑料碗容易滋生细菌。碗口要够宽，防止猫咪胡须疲劳。</p>
<p><strong>猫抓板：</strong>这是保护你家具的神器！选择瓦楞纸或剑麻材质的猫抓板，放在猫咪经常活动的地方。</p>
<h2>二、饮食准备</h2>
<p><strong>猫粮：</strong>接猫前先了解猫咪之前吃的什么粮，接回家后不要立即换粮。如需更换，采用"七日换粮法"逐步过渡。</p>
<p><strong>零食：</strong>建议准备一些冻干或肉泥类零食，用于训练和安抚。但零食不能替代主食，每日零食量不超过总食量的10%。</p>
<h2>三、健康护理</h2>
<p><strong>疫苗：</strong>幼猫需要在8周、12周和16周龄时分别接种猫三联疫苗。成年猫每年加强一次。</p>
<p><strong>驱虫：</strong>体内驱虫每3个月一次，体外驱虫每月一次。即使猫咪不出门，也需要定期驱虫。</p>
<p><strong>绝育：</strong>建议在猫咪6-8个月大时进行绝育手术，可以有效预防多种疾病，也能改善猫咪的行为问题。</p>
<h2>四、环境安全</h2>
<p>封窗是重中之重！每年都有大量猫咪因未封窗而坠楼。请确保所有窗户都有牢固的防护网。同时，将家中的有毒植物（如百合、郁金香）和对猫咪有害的物品妥善收纳。</p>
<h2>五、心理准备</h2>
<p>猫咪刚到家时可能会躲起来不吃不喝，这是正常现象。给它时间和空间适应新环境，不要强行抱它或追赶它。通常3-7天后，猫咪就会逐渐放松下来。</p>
<p>养猫是一份长达十几年的承诺，请确保你已经做好了充分的准备。祝你和你的新伙伴相处愉快！</p>`,
    category: "yanghu",
    categoryName: "猫咪养护",
    imageSeq: "article-novice-guide",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20close-up%20photograph%20of%20a%20beautiful%20fluffy%20orange%20tabby%20cat%20with%20big%20eyes%20in%20a%20warm%20cozy%20home%20setting%2C%20soft%20natural%20morning%20lighting%2C%20cream%20and%20beige%20background%20with%20minimalist%20decor%2C%20shallow%20depth%20of%20field%2C%20warm%20aesthetic%20photography%2C%20high%20detail&width=800&height=500&seq=article-novice-guide&orientation=landscape",
    author: "猫咪达人小王",
    authorAvatar: "https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20a%20smiling%20Asian%20young%20woman%20with%20soft%20lighting%2C%20friendly%20expression%2C%20minimalist%20cream%20background%2C%20professional%20headshot%20style%2C%20natural%20warm%20tones&width=100&height=100&seq=avatar-1&orientation=squarish",
    date: "2026-08-05",
    readCount: 12580,
    likeCount: 896,
    commentCount: 234,
    tags: ["新手养猫", "养猫必备", "猫咪用品", "接猫准备"],
  },
  {
    id: "article-2",
    title: "猫咪呕吐别慌张！常见原因分析与应对方法",
    summary: "猫咪呕吐是铲屎官们最常遇到的问题之一。是吐毛球还是生病了？什么时候该立即就医？本文为你详细解析猫咪呕吐的各种原因和应对策略。",
    content: `<p>作为铲屎官，几乎每个人都经历过猫咪呕吐的情况。看到自家主子吐了，心里肯定很着急。但并非所有呕吐都需要立即冲去宠物医院，让我们来了解一下猫咪呕吐的常见原因和应对方法。</p>
<h2>一、生理性呕吐（通常不需要太担心）</h2>
<h3>1. 吐毛球</h3>
<p>这是最常见的呕吐原因。猫咪舔毛时会吞入大量毛发，这些毛发在胃里聚集成团，刺激胃部引发呕吐。吐出的毛球通常呈圆柱形，混有少量食物或液体。</p>
<p><strong>预防方法：</strong>定期给猫咪梳毛，喂食化毛膏或猫草，选择含纤维素的猫粮帮助毛球排出。</p>
<h3>2. 进食过快</h3>
<p>有些猫咪吃太快，食物来不及消化就被吐出来，吐出的食物基本还是原样。</p>
<p><strong>解决方法：</strong>使用慢食碗，少量多餐，避免一次性放太多食物。</p>
<h2>二、需要警惕的病理性呕吐</h2>
<h3>1. 肠胃炎</h3>
<p>症状：频繁呕吐，可能伴有腹泻、精神不振、食欲下降。</p>
<p><strong>应对：</strong>禁食12-24小时（不禁水），观察猫咪状态。如持续呕吐或出现脱水，需立即就医。</p>
<h3>2. 异物堵塞</h3>
<p>猫咪可能吞食了线头、塑料、小玩具等异物，导致消化道堵塞。</p>
<p><strong>危险信号：</strong>反复干呕、腹部疼痛、无法排便。这是紧急情况，需要立即手术取出！</p>
<h3>3. 肾脏疾病</h3>
<p>老年猫咪常见，伴随多饮多尿、体重下降、口腔溃疡等症状。</p>
<p><strong>应对：</strong>定期体检非常重要，早期发现可以通过饮食管理和药物治疗控制病情。</p>
<h2>三、何时必须立即就医？</h2>
<ul>
<li>24小时内呕吐超过3次</li>
<li>呕吐物中带血（鲜红或咖啡色）</li>
<li>伴随精神萎靡、发烧、腹泻</li>
<li>怀疑吞食异物或有毒物质</li>
<li>猫咪明显腹痛（弓背、不愿意被摸肚子）</li>
</ul>
<p>最后提醒各位铲屎官：平时多观察猫咪的正常状态，才能及时发现异常。有任何不确定的情况，宁可多跑一趟医院，也不要耽误最佳治疗时机。</p>`,
    category: "jiankang",
    categoryName: "健康问答",
    imageSeq: "article-vomit-guide",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20cute%20gray%20British%20Shorthair%20cat%20sitting%20elegantly%20on%20a%20soft%20cream%20sofa%2C%20warm%20afternoon%20sunlight%20filtering%20through%20window%2C%20minimalist%20beige%20interior%2C%20peaceful%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20professional%20pet%20photography&width=800&height=500&seq=article-vomit-guide&orientation=landscape",
    author: "宠物医生老张",
    authorAvatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20an%20Asian%20middle-aged%20man%20in%20white%20coat%2C%20warm%20smile%2C%20veterinary%20professional%2C%20clean%20clinic%20background%20out%20of%20focus&width=100&height=100&seq=avatar-2&orientation=squarish",
    date: "2026-08-03",
    readCount: 9820,
    likeCount: 654,
    commentCount: 189,
    tags: ["猫咪呕吐", "猫咪健康", "宠物医疗", "常见病症"],
  },
  {
    id: "article-3",
    title: "晒猫啦！我家英短蓝猫的365天成长记录",
    summary: "从两个月大的小奶猫到一岁的大胖墩，记录我家英短蓝猫「团子」一年来的成长变化。大量萌图预警，准备好被治愈吧！",
    content: `<p>2025年8月3日，我永远记得这一天——团子来到了我的生活中。当时它才两个月大，小小的一团缩在猫包里，用怯生生的蓝眼睛打量着我。那一刻我就知道，这个小家伙会成为我生命中不可或缺的一部分。</p>
<h2>刚到家的第一周</h2>
<p>团子刚到家时特别胆小，躲在沙发底下整整两天不肯出来。我把猫粮和水放在沙发旁边，然后远远地坐着，轻声跟它说话。第三天晚上，它终于小心翼翼地爬出来吃了一口粮，然后又飞快地缩回去了。虽然只有短短几秒，但那一刻我激动得差点掉眼泪。</p>
<h2>两个月的飞速成长期</h2>
<p>英短真的长得特别快！三个月大的时候，团子已经从巴掌大长到了小臂长。这个阶段它特别活泼，每天在家里跑酷，最喜欢的玩具是逗猫棒和那个会发光的球。对了，它还学会了开推拉门——是的，我家的推拉门现在已经形同虚设了。</p>
<h2>半岁——尴尬期也挡不住的可爱</h2>
<p>六个月左右的时候，团子进入了尴尬期，身体拉长了但还没长肉，看起来有点像一只小狐狸。不过这个阶段它开始变得特别粘人，每天晚上都会跳上床，在我枕头边找个位置蜷成一团，呼噜声像小马达一样。</p>
<h2>一岁生日——从小奶猫到大胖墩</h2>
<p>2026年8月3日，团子一岁了！现在的它已经是一只标准的英短体型——圆脸、圆眼、圆身子，抱起来沉甸甸的，手感好到爆炸。最喜欢的活动从跑酷变成了在窗台上晒太阳和监视窗外的小鸟。</p>
<p>回顾这一年，有团子陪伴的日子真的太美好了。它教会了我耐心、责任和无条件的爱。每一只猫咪都是独一无二的小天使，希望每一个铲屎官都能珍惜和主子在一起的每一天。</p>
<p><em>（本文配图为团子各阶段的成长照片，都已上传到萌猫图集）</em></p>`,
    category: "mengtu",
    categoryName: "萌猫图片",
    imageSeq: "article-cat-growth",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20playful%20kitten%20with%20blue%20eyes%20reaching%20up%20towards%20a%20feather%20toy%2C%20soft%20cream%20backdrop%2C%20warm%20natural%20window%20light%2C%20adorable%20action%20shot%2C%20shallow%20depth%20of%20field%2C%20dreamy%20atmosphere&width=800&height=500&seq=article-cat-growth&orientation=landscape",
    author: "团子麻麻",
    authorAvatar: "https://readdy.ai/api/search-image?query=Gentle%20portrait%20of%20a%20young%20Asian%20woman%20with%20warm%20smile%2C%20casual%20home%20setting%2C%20soft%20natural%20window%20light%2C%20cozy%20atmosphere&width=100&height=100&seq=avatar-3&orientation=squarish",
    date: "2026-08-03",
    readCount: 15600,
    likeCount: 1230,
    commentCount: 345,
    tags: ["英短蓝猫", "猫咪成长", "萌猫日常", "养猫日记"],
  },
  {
    id: "article-4",
    title: "【北京】三只可爱小橘猫找领养，已驱虫已疫苗",
    summary: "小区救助的三只小橘猫，两个月大，身体健康性格亲人，已做驱虫和第一针疫苗。坐标北京朝阳区，希望找到真心爱猫的铲屎官。",
    content: `<p>上个月在小区里发现了这三只被遗弃的小橘猫，当时它们挤在一个纸箱里瑟瑟发抖。经过一个月的照顾，三小只现在都健康活泼，正式开始寻找领养家庭。</p>
<h2>三小只的基本情况</h2>
<p><strong>萌萌（哥哥）：</strong>三只中最大胆的，第一个学会用猫砂盆。性格活泼外向，喜欢跟人互动，尤其爱玩逗猫棒。毛色是标准的橘色虎斑纹。</p>
<p><strong>圆圆（姐姐）：</strong>性格偏安静，喜欢在窗台上晒太阳。偶尔会发出撒娇的小奶音，特别治愈。毛色偏浅，带一点奶油橘的感觉。</p>
<p><strong>豆豆（妹妹）：</strong>三小只里最粘人的，走到哪跟到哪，一坐下来就往腿上爬。超级喜欢被摸下巴，一摸就咕噜咕噜。</p>
<h2>健康状况</h2>
<ul>
<li>年龄：约2个月</li>
<li>体内外驱虫：已完成</li>
<li>疫苗：第一针猫三联已完成</li>
<li>健康状况：良好，无任何疾病</li>
<li>饮食：已断奶，吃幼猫粮和主食罐头</li>
<li>猫砂：会用豆腐猫砂</li>
</ul>
<h2>领养要求</h2>
<ol>
<li>北京本地，有稳定住所（需封窗）</li>
<li>家庭成员同意养猫，房东允许饲养宠物</li>
<li>科学喂养，不喂劣质猫粮</li>
<li>适龄绝育，定期疫苗驱虫</li>
<li>接受回访（可线上，不会频繁打扰）</li>
<li>不因搬家、结婚、怀孕等原因弃养</li>
</ol>
<p>如果你真心喜欢猫咪，愿意给这些小生命一个温暖的家，请联系我。领养前我会和你详细沟通，确保猫咪能找到最适合的主人。</p>
<p>让领养代替购买，给流浪的小天使们一个家！</p>`,
    category: "lingyang",
    categoryName: "领养信息",
    imageSeq: "article-adoption",
    imageUrl: "https://readdy.ai/api/search-image?query=Three%20tiny%20orange%20tabby%20kittens%20cuddled%20together%20on%20a%20soft%20cream%20blanket%2C%20warm%20and%20tender%20scene%2C%20soft%20morning%20light%2C%20beige%20minimalist%20room%2C%20heartwarming%20atmosphere%2C%20shallow%20depth%20of%20field&width=800&height=500&seq=article-adoption&orientation=landscape",
    author: "朝阳区猫奴小李",
    authorAvatar: "https://readdy.ai/api/search-image?query=Friendly%20portrait%20of%20a%20young%20Asian%20man%20with%20kind%20eyes%2C%20outdoor%20park%20background%20softly%20blurred%2C%20natural%20daylight&width=100&height=100&seq=avatar-4&orientation=squarish",
    date: "2026-08-01",
    readCount: 7650,
    likeCount: 890,
    commentCount: 156,
    tags: ["猫咪领养", "北京领养", "橘猫", "流浪猫救助"],
  },
  {
    id: "article-5",
    title: "猫咪为什么喜欢踩奶？这个行为背后的秘密",
    summary: "很多铲屎官都经历过被猫咪'踩奶'的时刻。这个软萌的行为到底意味着什么？是把你当妈妈了，还是在标记领地？科学解读猫咪踩奶行为。",
    content: `<p>如果你养过猫，大概率经历过这样的场景：猫咪爬到你身上，用前爪在你身上有节奏地按压，同时发出满足的咕噜声。这个行为叫做"踩奶"（kneading），是猫咪最可爱的行为之一。但它到底代表什么呢？</p>
<h2>一、源自幼年时期的本能</h2>
<p>踩奶行为可以追溯到猫咪刚出生的时候。幼猫在吃奶时，会用前爪按压母猫的乳房周围，这个动作可以刺激乳汁分泌。所以当你家猫咪在你身上踩奶时，它在用最原始的方式表达舒适和满足——就像回到了吃奶的婴儿时期。</p>
<h2>二、表达极度的信任和安全感</h2>
<p>猫咪是既警惕又敏感的动物，它们只会在感觉绝对安全的环境下才会做出踩奶这种"退行性行为"。一只踩奶的猫咪，是把自己最脆弱、最柔软的一面毫无保留地展现给了你。这是猫咪对你最高级别的信任。</p>
<h2>三、领地标记行为</h2>
<p>猫咪的爪垫上有气味腺，踩奶的同时也在释放信息素，标记"这是我的地盘"和"这是我的专属人类"。所以当你家猫咪在你身上踩奶时，它不仅是在表达爱意，还是在向全世界宣告：这个人，是我的。</p>
<h2>四、准备睡觉的信号</h2>
<p>很多猫咪在睡前会踩奶，这可能是延续了野生祖先在草丛中踩踏出一个舒适睡觉位置的习惯。如果你看到猫咪在被子上踩奶然后蜷成一团睡着了，说明它觉得这里是最舒服的床。</p>
<h2>五、发情期的表现</h2>
<p>未绝育的母猫在发情期也可能表现出更频繁的踩奶行为，同时伴随翘屁股、大声叫唤等行为。如果猫咪已经适龄，建议尽快安排绝育手术。</p>
<p>总之，猫咪踩奶是一件非常美好的事情。下次当你家主子在你身上踩奶时，好好享受这份被爱和被信任的感觉吧！</p>`,
    category: "xingwei",
    categoryName: "行为解读",
    imageSeq: "article-kneading",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20close-up%20of%20cat%20paws%20gently%20kneading%20on%20a%20soft%20cream%20throw%20blanket%2C%20warm%20cozy%20living%20room%20setting%2C%20soft%20golden%20lighting%2C%20intimate%20and%20peaceful%20mood%2C%20shallow%20depth%20of%20field%2C%20artistic%20photography&width=800&height=500&seq=article-kneading&orientation=landscape",
    author: "猫咪行为学家阿琳",
    authorAvatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20an%20Asian%20woman%20with%20intelligent%20expression%2C%20warm%20indoor%20setting%20with%20books%2C%20soft%20lighting%2C%20scholarly%20vibe&width=100&height=100&seq=avatar-5&orientation=squarish",
    date: "2026-07-30",
    readCount: 11200,
    likeCount: 756,
    commentCount: 198,
    tags: ["猫咪行为", "踩奶", "猫咪心理学", "冷知识"],
  },
  {
    id: "article-6",
    title: "猫咪可以吃的人类食物清单（附禁忌食物表）",
    summary: "每次吃饭时猫咪都眼巴巴地看着你？别心软！有些人类食物猫咪可以适量吃，但有些却是致命的。收好这份猫咪安全食物清单。",
    content: `<p>每次你在餐桌前吃饭，脚边总会多出一双（或好几双）期待的眼睛。很多铲屎官会忍不住想分享一点给猫咪，但你真的知道哪些食物猫咪可以吃、哪些绝对不能碰吗？</p>
<h2>一、猫咪可以适量吃的人类食物</h2>
<h3>肉类</h3>
<ul>
<li><strong>鸡胸肉：</strong>煮熟后撕成细丝，不加任何调料，是猫咪最爱的健康零食。</li>
<li><strong>三文鱼：</strong>富含Omega-3脂肪酸，对猫咪皮肤和毛发有益。必须煮熟，生鱼可能含有寄生虫。</li>
<li><strong>牛肉：</strong>瘦牛肉切小块煮熟，偶尔作为奖励。</li>
<li><strong>虾仁：</strong>煮熟去壳，高蛋白低脂肪的好选择。</li>
</ul>
<h3>蔬菜</h3>
<ul>
<li><strong>南瓜：</strong>蒸熟后少量喂食，有助于消化和排便。</li>
<li><strong>胡萝卜：</strong>煮熟后切碎，富含维生素A。</li>
<li><strong>西兰花：</strong>少量煮熟，含有抗氧化成分。</li>
</ul>
<h3>水果</h3>
<ul>
<li><strong>蓝莓：</strong>富含抗氧化剂，但猫咪可能不太感兴趣。</li>
<li><strong>西瓜：</strong>去籽后少量喂食，帮助夏季补水。</li>
<li><strong>香蕉：</strong>极少量，高糖分不适合多吃。</li>
</ul>
<p><strong>重要提醒：</strong>以上食物都只能作为零食（不超过每日热量摄入的10%），不能替代猫粮。所有食物都需要煮熟、不加调料。</p>
<h2>二、绝对不能给猫咪吃的食物</h2>
<ul>
<li><strong>洋葱和大蒜：</strong>含有破坏猫咪红细胞的物质，会引起溶血性贫血。所有葱属植物都危险！</li>
<li><strong>巧克力：</strong>含有可可碱，对猫咪心脏和神经系统有毒。越黑的巧克力越危险。</li>
<li><strong>葡萄和葡萄干：</strong>会导致猫咪急性肾衰竭，即使少量也可能致命。</li>
<li><strong>生鸡蛋：</strong>可能含有沙门氏菌，而且生蛋白会影响维生素B的吸收。</li>
<li><strong>牛奶和奶制品：</strong>大多数成年猫咪乳糖不耐受，喝牛奶会拉肚子。</li>
<li><strong>咖啡和茶：</strong>咖啡因对猫咪来说是有毒的。</li>
<li><strong>酒精：</strong>即使一点点也可能导致严重中毒。</li>
</ul>
<p>记住：如果猫咪不小心误食了禁忌食物，请立即联系兽医！时间就是生命。</p>`,
    category: "yinshi",
    categoryName: "饮食营养",
    imageSeq: "article-food-guide",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20beautiful%20cat%20curiously%20looking%20at%20a%20bowl%20of%20fresh%20food%20on%20a%20wooden%20table%2C%20warm%20kitchen%20setting%20with%20soft%20natural%20light%2C%20cream%20minimalist%20interior%2C%20clean%20aesthetic%2C%20high%20quality%20pet%20photography&width=800&height=500&seq=article-food-guide&orientation=landscape",
    author: "营养师猫妈",
    authorAvatar: "https://readdy.ai/api/search-image?query=Warm%20professional%20portrait%20of%20an%20Asian%20woman%20in%20cozy%20kitchen%20setting%2C%20friendly%20smile%2C%20natural%20light%20from%20window%2C%20homely%20atmosphere&width=100&height=100&seq=avatar-6&orientation=squarish",
    date: "2026-07-28",
    readCount: 14300,
    likeCount: 1020,
    commentCount: 287,
    tags: ["猫咪饮食", "猫咪营养", "安全食物", "禁忌食物"],
  },
  {
    id: "article-7",
    title: "猫咪掉毛严重怎么办？6个实用方法告别满屋飞毛",
    summary: "又到了换毛季，家里到处都是猫毛？别愁！从日常梳理到饮食调理，这6个科学有效的方法帮你轻松应对猫咪掉毛问题。",
    content: `<p>养猫人的共同烦恼之一：衣服上永远有猫毛，沙发上永远有猫毛，甚至饭里也偶尔会发现一根猫毛。尤其是换季时期，猫咪掉毛量简直让人怀疑它是不是打算秃了。别担心，以下6个科学方法帮你有效减少家里的猫毛。</p>
<h2>1. 每天梳毛——最基本也最有效</h2>
<p>每天花10-15分钟给猫咪梳毛，可以去除大量即将脱落的死毛，从源头减少猫毛飘散。短毛猫推荐使用硅胶梳或鬃毛刷，长毛猫则需要排梳和针梳配合使用。梳毛也是增进感情的好时机！</p>
<h2>2. 选择合适的猫粮</h2>
<p>猫咪掉毛严重可能与营养不足有关。选择富含Omega-3和Omega-6脂肪酸的猫粮，可以改善皮肤健康和毛发质量。含有生物素和锌的配方也有助于减少掉毛。</p>
<h2>3. 保证充足饮水</h2>
<p>脱水会导致猫咪皮肤干燥，加剧掉毛。很多猫咪不喜欢喝静止的水，可以考虑购买宠物饮水机，流动的水更能吸引猫咪喝水。也可以在湿粮中额外加水。</p>
<h2>4. 定期洗澡（但不要太频繁）</h2>
<p>长毛猫建议每1-2个月洗一次澡，短毛猫每2-3个月一次。使用猫咪专用沐浴露，温水冲洗干净。洗澡太频繁反而会破坏皮肤油脂平衡，导致更多掉毛。</p>
<h2>5. 环境清洁工具升级</h2>
<p>投资一个好的吸尘器（最好是带宠物毛发专用吸头的），以及粘毛器和除毛滚筒。空气净化器也能有效减少空气中飘浮的猫毛和皮屑。</p>
<h2>6. 关注健康问题</h2>
<p>如果猫咪掉毛量突然激增，或出现斑秃、皮肤红肿等情况，可能是有健康问题：真菌感染、寄生虫、过敏、内分泌失调等。及时带猫咪去看兽医，对症治疗。</p>
<p>养猫就要接受猫毛的存在，我们只能尽量减少，不可能完全消除。与其为猫毛烦恼，不如把它当作猫咪留给你的小印记吧！</p>`,
    category: "yanghu",
    categoryName: "猫咪养护",
    imageSeq: "article-shedding",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20fluffy%20white%20Persian%20cat%20being%20gently%20brushed%20on%20a%20cozy%20sofa%2C%20soft%20warm%20indoor%20lighting%2C%20cream%20and%20beige%20interior%2C%20peaceful%20grooming%20moment%2C%20shallow%20depth%20of%20field%2C%20tender%20atmosphere&width=800&height=500&seq=article-shedding&orientation=landscape",
    author: "猫咪达人小王",
    authorAvatar: "https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20a%20smiling%20Asian%20young%20woman%20with%20soft%20lighting%2C%20friendly%20expression%2C%20minimalist%20cream%20background%2C%20professional%20headshot%20style%2C%20natural%20warm%20tones&width=100&height=100&seq=avatar-1&orientation=squarish",
    date: "2026-07-25",
    readCount: 8900,
    likeCount: 567,
    commentCount: 134,
    tags: ["猫咪掉毛", "换毛季", "猫咪护理", "日常养护"],
  },
  {
    id: "article-8",
    title: "多猫家庭的和谐相处之道：从打架到互相舔毛",
    summary: "家里养了两只以上的猫？新猫进家后原住民不乐意？别担心，多猫家庭的管理是有方法的。本文分享多猫和平共处的实用策略。",
    content: `<p>很多铲屎官在养了第一只猫之后，会忍不住想再养一只。但是，猫咪是领地意识很强的动物，新成员的加入可能会引发一系列问题。我家三只猫从最初的哈气打架到现在的互相舔毛睡觉，这中间走了不少弯路，也总结出了一些经验。</p>
<h2>一、新猫进家的隔离期——最重要的一步</h2>
<p>无论新猫看起来多么健康，都必须先隔离7-14天。这不仅是为了防止传染病，更是为了让两只猫在不见面的情况下先熟悉彼此的气味。</p>
<p><strong>具体做法：</strong>新猫单独放在一个房间，准备独立的猫砂盆、食碗和水碗。每天交换两只猫用过的毯子或玩具，让它们先通过气味认识对方。</p>
<h2>二、逐步见面——急不得</h2>
<p>隔离期过后，可以先隔着门缝或纱窗让它们看到彼此但接触不到。如果两只猫都没有表现出明显的敌意（哈气、炸毛、低吼），可以尝试在有监督的情况下短暂见面。</p>
<p><strong>小技巧：</strong>见面时给双方提供零食或玩具，让它们把"另一只猫的出现"和"好事发生"联系起来。</p>
<h2>三、资源充足——避免竞争</h2>
<p>多猫家庭最核心的原则：猫砂盆数量=N+1（N是猫咪数量），食碗和水碗也要分开摆放。每只猫都需要有自己的"安全空间"——猫爬架、猫窝、窗台等高处是不错的选择。</p>
<h2>四、公平对待——不要让任何一只猫感觉被冷落</h2>
<p>新猫来了之后，很多人会不自觉地多关注新猫。这会让原住民产生嫉妒和不安全感。正确的做法是：多给原住民关注和奖励，让它知道新成员的到来不会影响它在家的地位。</p>
<h2>五、接受现实——不是所有猫都能成为好朋友</h2>
<p>有些猫咪天生不合，能做到井水不犯河水已经很好了。只要不打架受伤，各自安好也是一种和谐。不要强求所有猫咪都相亲相爱。</p>
<p>养多只猫虽然有时候挺累的，但看着它们慢慢从陌生到熟悉，从小打小闹到互相依偎，那种成就感真的无可替代！</p>`,
    category: "xingwei",
    categoryName: "行为解读",
    imageSeq: "article-multi-cat",
    imageUrl: "https://readdy.ai/api/search-image?query=Two%20cats%20one%20orange%20tabby%20and%20one%20black%20cat%20sleeping%20peacefully%20together%20on%20a%20cream%20colored%20armchair%2C%20warm%20afternoon%20sunlight%2C%20cozy%20living%20room%2C%20harmony%20and%20companionship%20vibe%2C%20shallow%20depth%20of%20field&width=800&height=500&seq=article-multi-cat&orientation=landscape",
    author: "猫咪行为学家阿琳",
    authorAvatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20an%20Asian%20woman%20with%20intelligent%20expression%2C%20warm%20indoor%20setting%20with%20books%2C%20soft%20lighting%2C%20scholarly%20vibe&width=100&height=100&seq=avatar-5&orientation=squarish",
    date: "2026-07-22",
    readCount: 7200,
    likeCount: 489,
    commentCount: 112,
    tags: ["多猫家庭", "猫咪社交", "新猫进家", "猫咪行为"],
  },
  {
    id: "article-9",
    title: "猫咪年度体检指南：不同年龄段该查什么？",
    summary: "很多铲屎官觉得猫咪不出门就不用体检，这是最大的误区。定期体检能在疾病早期发现问题。来看看你家猫咪在不同年龄段该做什么检查。",
    content: `<p>"我家猫从来不出门，看起来很健康啊，为什么要体检？"这是兽医最常听到的问题之一。事实上，猫咪是天生的"隐病高手"，等到你发现不对劲的时候，可能已经错过了最佳治疗时机。定期体检是延长猫咪寿命最有效的方法。</p>
<h2>幼猫期（0-1岁）——打好健康基础</h2>
<p><strong>基础检查项目：</strong></p>
<ul>
<li>体格检查（体重、体温、听诊）</li>
<li>猫三联疫苗接种（8周、12周、16周）</li>
<li>狂犬疫苗接种</li>
<li>体内外驱虫</li>
<li>血常规检查</li>
<li>猫瘟、猫艾滋检测</li>
</ul>
<h2>青壮年期（1-7岁）——年度体检是关键</h2>
<p><strong>建议每年一次的检查项目：</strong></p>
<ul>
<li>全面体格检查</li>
<li>血常规+生化全项（肝肾功能、血糖等）</li>
<li>尿常规</li>
<li>粪便检查（寄生虫）</li>
<li>口腔检查（牙结石、牙龈炎）</li>
<li>疫苗加强针</li>
</ul>
<h2>中老年期（7岁以上）——半年一次更安心</h2>
<p>猫咪7岁以后进入中老年，各种慢性病风险显著增加。建议每6个月体检一次，除了上述项目外，还需增加：</p>
<ul>
<li>甲状腺功能检测（T4）——老年猫甲亢高发</li>
<li>血压测量——肾病患者常见高血压</li>
<li>心脏超声——筛查心肌病</li>
<li>腹部超声——检查肾脏、肝脏、胰腺</li>
<li>SDMA检测——早期肾病筛查，比肌酐更敏感</li>
</ul>
<h2>需要特别注意的信号</h2>
<p>即使不在体检时间，如果猫咪出现以下情况，也要及时就医：</p>
<ul>
<li>饮水量和尿量突然增多</li>
<li>体重明显下降或增加</li>
<li>食欲变化</li>
<li>呕吐或腹泻持续超过24小时</li>
<li>精神萎靡，不爱活动</li>
<li>呼吸急促或张口呼吸</li>
</ul>
<p>爱它，就带它去体检。一次体检的费用，远低于疾病晚期的治疗费用——更重要的是，你的猫咪可以少受很多痛苦。</p>`,
    category: "jiankang",
    categoryName: "健康问答",
    imageSeq: "article-checkup",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20veterinarian%20in%20white%20coat%20gently%20examining%20a%20calm%20cat%20on%20an%20examination%20table%2C%20clean%20bright%20clinic%20setting%2C%20professional%20yet%20warm%20atmosphere%2C%20soft%20lighting%2C%20caring%20scene&width=800&height=500&seq=article-checkup&orientation=landscape",
    author: "宠物医生老张",
    authorAvatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20an%20Asian%20middle-aged%20man%20in%20white%20coat%2C%20warm%20smile%2C%20veterinary%20professional%2C%20clean%20clinic%20background%20out%20of%20focus&width=100&height=100&seq=avatar-2&orientation=squarish",
    date: "2026-07-20",
    readCount: 6500,
    likeCount: 432,
    commentCount: 98,
    tags: ["猫咪体检", "猫咪健康", "老年猫", "预防医学"],
  },
  {
    id: "article-10",
    title: "【上海】流浪布偶猫救助后续：小公主找到新家啦",
    summary: "上个月在闵行区救助的流浪布偶猫'小雪'经过治疗和调理，已经恢复了健康。更让人开心的是，它终于找到了一个超级爱它的新主人！",
    content: `<p>上个月我们在上海闵行区的一个小区角落发现了小雪，当时它蜷缩在一个废弃的空调外机下面，毛发打结、骨瘦如柴，完全看不出布偶猫应有的美貌。经过一个月的救助和治疗，小雪不仅恢复了健康，还找到了永远的家。</p>
<h2>救助经过</h2>
<p>发现小雪的那天下着小雨，它的白色长毛被泥水浸透，眼角有分泌物，看起来非常虚弱。我们用猫条慢慢靠近它，它虽然警惕但没有逃跑——这让我们怀疑它可能曾经是家猫，因为某种原因被遗弃了。</p>
<p>带去医院检查后发现：营养不良、耳螨严重、轻度贫血，还有一处旧伤已经愈合。让人心酸的是，它体内有芯片，但原主人留下的电话已经停机了。</p>
<h2>治疗和恢复</h2>
<p>经过三周的精心治疗和照顾，小雪的变化惊人：毛发重新变得蓬松柔软，蓝色的眼睛恢复了神采，体重从2.8kg涨到了3.5kg。更重要的是，它重新建立起了对人类的信任，会主动蹭过来要求摸摸。</p>
<h2>领养故事</h2>
<p>在发出领养信息后，我们收到了47份申请。经过仔细筛选和家访，最终选择了家住浦东新区的陈女士。陈女士有10年养猫经验，家中已有一只6岁的英短，前年刚送走了一只18岁的老猫，有丰富的猫咪护理经验。</p>
<p>上周末小雪正式搬进了新家。陈女士发来的照片里，小雪已经霸占了猫爬架的最高层，新家的原住民英短在下面好奇地张望。虽然还需要时间磨合，但这是一个美好的开始。</p>
<p>每一个被救助的流浪猫都值得拥有一个温暖的家。感谢所有关心和帮助过小雪的朋友们！</p>`,
    category: "lingyang",
    categoryName: "领养信息",
    imageSeq: "article-rescue",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20rescued%20fluffy%20ragdoll%20cat%20with%20blue%20eyes%20resting%20comfortably%20on%20a%20soft%20pillow%2C%20warm%20cozy%20home%20environment%2C%20soft%20natural%20light%2C%20hopeful%20and%20peaceful%20atmosphere%2C%20healing%20theme&width=800&height=500&seq=article-rescue&orientation=landscape",
    author: "上海猫咪救助站",
    authorAvatar: "https://readdy.ai/api/search-image?query=Compassionate%20portrait%20of%20an%20Asian%20woman%20volunteer%20at%20animal%20shelter%2C%20warm%20and%20caring%20expression%2C%20soft%20indoor%20lighting%2C%20simple%20background&width=100&height=100&seq=avatar-7&orientation=squarish",
    date: "2026-07-18",
    readCount: 8900,
    likeCount: 1120,
    commentCount: 203,
    tags: ["猫咪救助", "布偶猫", "领养后续", "上海领养"],
  },
  {
    id: "article-11",
    title: "自制健康猫饭全攻略：从选材到配方一次学会",
    summary: "想给猫咪做健康美味的自制猫饭？别瞎做！猫咪的营养需求和人类完全不同。本文提供科学的自制猫饭配方和制作要点。",
    content: `<p>越来越多的铲屎官开始尝试给猫咪做自制猫饭，既能保证食材新鲜，又能避免商业猫粮中的添加剂。但是，猫咪是纯粹的肉食动物，它们的营养需求与人类有本质区别。随意搭配食材可能导致营养不良，甚至引发严重健康问题。</p>
<h2>一、猫咪的核心营养需求</h2>
<p>猫咪必须从食物中获取的关键营养素：</p>
<ul>
<li><strong>牛磺酸：</strong>猫咪无法自身合成，缺乏会导致失明和心脏病。心脏和深色肉类中含量丰富。</li>
<li><strong>精氨酸：</strong>必需氨基酸，缺乏会导致高氨血症。</li>
<li><strong>花生四烯酸：</strong>猫咪不能从植物中转化，必须从动物脂肪中获取。</li>
<li><strong>维生素A：</strong>猫咪不能将β-胡萝卜素转化为维生素A，必须直接摄入。</li>
<li><strong>维生素D：</strong>猫咪皮肤无法通过日晒合成维生素D。</li>
</ul>
<h2>二、基础猫饭配方（需配合营养粉使用）</h2>
<p><strong>食材比例：</strong></p>
<ul>
<li>80-85% 肉类（鸡腿肉、鸡胸肉、牛肉、鸭肉等轮换使用）</li>
<li>5-10% 内脏（鸡心、鸡肝、鸡胗等，肝脏不超过5%）</li>
<li>5-10% 其他（蛋黄、少量南瓜泥等）</li>
</ul>
<p><strong>制作方法：</strong></p>
<ol>
<li>所有肉类切小块，去除多余脂肪和骨头</li>
<li>隔水蒸熟（不要煮，水煮会流失大量营养）</li>
<li>加入适量猫咪专用营养粉（确保微量元素的全面补充）</li>
<li>放凉后给猫咪食用</li>
</ol>
<h2>三、必须避免的错误</h2>
<ul>
<li><strong>只喂鸡胸肉：</strong>营养极度单一，长期会导致严重营养不良</li>
<li><strong>不放营养粉：</strong>自制猫饭普遍缺乏钙、碘等微量元素</li>
<li><strong>加盐加调味料：</strong>猫咪不需要人类的调味品</li>
<li><strong>喂生肉：</strong>存在寄生虫和细菌感染风险</li>
<li><strong>完全替代猫粮前不咨询兽医：</strong>自制猫饭需要非常精细的营养配比</li>
</ul>
<p><strong>重要提醒：</strong>自制猫饭建议作为猫粮的补充（占比不超过50%），而不是完全替代。如果你想让猫咪完全吃自制食物，务必在兽医或宠物营养师指导下进行。</p>`,
    category: "yinshi",
    categoryName: "饮食营养",
    imageSeq: "article-cat-food",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20cat%20enjoying%20a%20bowl%20of%20freshly%20prepared%20homemade%20cat%20food%20on%20a%20clean%20kitchen%20counter%2C%20warm%20natural%20light%2C%20cream%20minimalist%20kitchen%2C%20healthy%20pet%20nutrition%20theme%2C%20appetizing%20scene&width=800&height=500&seq=article-cat-food&orientation=landscape",
    author: "营养师猫妈",
    authorAvatar: "https://readdy.ai/api/search-image?query=Warm%20professional%20portrait%20of%20an%20Asian%20woman%20in%20cozy%20kitchen%20setting%2C%20friendly%20smile%2C%20natural%20light%20from%20window%2C%20homely%20atmosphere&width=100&height=100&seq=avatar-6&orientation=squarish",
    date: "2026-07-15",
    readCount: 10300,
    likeCount: 678,
    commentCount: 176,
    tags: ["自制猫饭", "猫咪营养", "科学喂养", "猫咪食谱"],
  },
  {
    id: "article-12",
    title: "震惊！原来猫咪的呼噜声还有这些神奇功效",
    summary: "猫咪的咕噜声不仅能治愈你的心，科学研究发现它还可能具有促进骨骼愈合、缓解压力等神奇功效。来了解猫咪呼噜背后的科学。",
    content: `<p>没有什么比一只在你怀里呼噜呼噜的猫咪更治愈的了。但你有没有想过，猫咪为什么要发出呼噜声？这个声音除了让人感到舒适，还有什么神奇的作用？</p>
<h2>一、呼噜声的物理特性</h2>
<p>猫咪的呼噜声频率在20-150赫兹之间，主要集中在25-50赫兹。有趣的是，这个频率范围恰好与医学上用于促进骨骼生长和伤口愈合的治疗性振动频率一致。这不是巧合——科学家认为猫咪的呼噜可能是一种自我修复的生理机制。</p>
<h2>二、呼噜声的多种含义</h2>
<h3>1. 满足和快乐</h3>
<p>这是最常见的理解。猫咪在被人抚摸、晒太阳、吃美食时发出的呼噜声，确实表达了满足和愉悦。</p>
<h3>2. 自我疗愈</h3>
<p>猫咪在受伤、分娩或生病时也会发出呼噜声。这不是因为它们"开心"，而是呼噜的振动可能在帮助身体恢复。有研究发现，猫咪的骨骼愈合速度比其他哺乳动物快很多，呼噜声可能是原因之一。</p>
<h3>3. 求助信号</h3>
<p>猫咪有一种特殊的"请求性呼噜"，频率更高，混合了一种类似婴儿哭声的频率在其中。这种呼噜声专门用来向人类"提要求"——通常是催饭。</p>
<h3>4. 母子沟通</h3>
<p>刚出生的小猫看不见也听不见，但能感受到母猫呼噜的振动，这帮助它们找到吃奶的位置，也是母子之间的情感纽带。</p>
<h2>三、对人类的健康益处</h2>
<ul>
<li><strong>降低压力：</strong>抚摸一只呼噜的猫咪可以降低人体皮质醇水平</li>
<li><strong>降低血压：</strong>研究表明，养猫的人心血管疾病风险比不养宠物的人低</li>
<li><strong>改善情绪：</strong>呼噜声能促进人体分泌催产素（"爱的荷尔蒙"）</li>
<li><strong>帮助睡眠：</strong>稳定的低频声音有助于放松和入睡</li>
</ul>
<p>所以，下次你家猫咪呼噜的时候，好好享受这份来自大自然的礼物吧——它不仅在表达对你的爱，还在用一种科学上可能有效的方式帮你放松身心呢！</p>`,
    category: "xingwei",
    categoryName: "行为解读",
    imageSeq: "article-purr",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20close-up%20of%20a%20cat%20purring%20with%20eyes%20half%20closed%20being%20gently%20petted%20by%20a%20human%20hand%2C%20warm%20intimate%20moment%2C%20soft%20golden%20lighting%2C%20cozy%20home%20setting%2C%20comfort%20and%20trust%20vibe%2C%20shallow%20depth%20of%20field&width=800&height=500&seq=article-purr&orientation=landscape",
    author: "猫咪行为学家阿琳",
    authorAvatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20an%20Asian%20woman%20with%20intelligent%20expression%2C%20warm%20indoor%20setting%20with%20books%2C%20soft%20lighting%2C%20scholarly%20vibe&width=100&height=100&seq=avatar-5&orientation=squarish",
    date: "2026-07-12",
    readCount: 18900,
    likeCount: 1560,
    commentCount: 412,
    tags: ["猫咪呼噜", "猫咪行为", "宠物疗愈", "冷知识"],
  },
];